export default {
    // 允许页面滚动
    AddScroll() {
        document.querySelector('.html').style.overflow = "visible"
    },
    // 禁止页面滚动
    RemoveScroll() {
        document.querySelector('.html').style.overflow = "hidden"
    }
}